import { Box, LinearProgress, Typography } from "@mui/material";
import { CGI_RED, CGI_SUCCESS, CGI_WARNING } from "../helpers/enums";

export default function LinearProgressWithLabel({
  progressValue,
  width = 200,
  header = false,
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <Box sx={{ width: width, mr: 1 }}>
        <LinearProgress
          variant="determinate"
          value={progressValue}
          sx={{
            "& .MuiLinearProgress-bar": {
              backgroundColor:
                progressValue < 50
                  ? CGI_RED
                  : progressValue < 75
                  ? CGI_WARNING
                  : CGI_SUCCESS,
            },
          }}
        />
      </Box>
      <Typography
        sx={{
          userSelect: "none",
          width: 45,
          fontWeight: header ? 500 : "normal",
          fontSize: header ? 17 : 15,
        }}
      >
        {Math.floor(progressValue)}%
      </Typography>
    </Box>
  );
}
